import React from 'react'
import { useI18n } from '../../i18n'
import { featureFlags } from '../../config/featureFlags'
import { GovernanceListingSection } from '../governance/GovernanceListingSection'
import { fetchDegradedControls, fetchOperationalPressure } from '../../services/controlAssuranceApi'

type Props = {
  standardCodes: string[]
}

export default function InformationSystemOperationalAssurancePanel({ standardCodes }: Props) {
  const { t } = useI18n()
  const [degradedCount, setDegradedCount] = React.useState(0)
  const [topPressure, setTopPressure] = React.useState<Array<{ controlCode?: string; operationalPressure: number }>>([])

  React.useEffect(() => {
    if (!featureFlags.CONTROL_ASSURANCE_V1) return
    const code = standardCodes[0]
    if (!code) return
    void Promise.all([fetchDegradedControls(code), fetchOperationalPressure(code)]).then(([d, p]) => {
      setDegradedCount(d.count || 0)
      setTopPressure((p.controls || []).slice(0, 5))
    })
  }, [standardCodes.join(',')])

  if (!featureFlags.CONTROL_ASSURANCE_V1) return null

  return (
    <GovernanceListingSection
      title={t('controlAssurance.operationalAssurance', 'Operational assurance')}
      description={t('controlAssurance.isPanelHint', 'Operationally degraded controls and telemetry-backed posture for this system.')}
    >
      <p className="text-xs text-slate-700 m-0">
        {t('controlAssurance.operationallyDegraded', 'Operationally degraded')}: {degradedCount}
      </p>
      {topPressure.length > 0 ? (
        <ul className="mt-2 m-0 p-0 list-none space-y-1">
          {topPressure.map((c, i) => (
            <li key={i} className="text-xs text-slate-600">
              {c.controlCode || '—'} — {t('controlAssurance.operationalPressure', 'Pressure')}{' '}
              {Math.round((c.operationalPressure || 0) * 100)}%
            </li>
          ))}
        </ul>
      ) : null}
    </GovernanceListingSection>
  )
}
